export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_003.88ae97ec.jpg";